import { StyleSheet } from 'aphrodite';
import { truncateTextStyle } from '../../../../styles/styles';

export const groupIconWidth = 30;

export const styleSheet = StyleSheet.create({
	editGroup: {
		width: '100%',
	},
	expandable: {
		position: 'relative',
	},
	expandedRowActions: {
		alignItems: 'center',
		display: 'flex',
		flex: '0.25',
		justifyContent: 'center',
		minWidth: 160,
		flexDirection: 'column',
	},
	groupItem: {
		':last-child': {
			borderBottom: '1px solid #D3DBDE77',
		},
		borderBottom: '1px solid #D3DBDE27',
		borderTop: '1px solid #D3DBDE27',
	},
	groupItemSubject: {
		paddingLeft: groupIconWidth,
		width: `calc(33% - ${groupIconWidth}px)`,
	},
	icon: {
		width: groupIconWidth,
	},
	row: {
		alignItems: 'center',
		cursor: 'default',
	},
	rowExpanded: {
		borderBottom: '1px solid #D3DBDE20',
	},
	subject: {
		':hover': {
			textDecoration: 'none',
		},
	},
	subjectCell: {
		cursor: 'pointer',
		...truncateTextStyle,
	},
	subjectTitle: {
		display: 'flex',
		flexDirection: 'row',
	},
});
